// Main application layout with sidebar
// Created as part of ENG2-1699: Create AppLayout Component with Sidebar

import React from 'react'
import { Box } from '@mui/material'
import Sidebar from './sidebar'
import { SidebarProvider, useSidebar } from './sidebar/sidebar-context'
import { tokens } from '../styles/tokens'
import { AppLayoutProps } from './sidebar/sidebar.types'

interface AppLayoutContentProps {
  children: React.ReactNode
  customerCount?: number
}

const AppLayoutContent: React.FC<AppLayoutContentProps> = ({ children, customerCount }) => {
  const { isCollapsed } = useSidebar()

  const sidebarWidth = isCollapsed
    ? tokens.layout.sidebarCollapsedWidth
    : tokens.layout.sidebarWidth

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
      }}
    >
      <Sidebar customerCount={customerCount} />

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          marginLeft: `${sidebarWidth}px`,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          transition: `margin-left ${tokens.transitions.normal}`,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

interface AppLayoutWithCountProps extends AppLayoutProps {
  customerCount?: number
}

const AppLayout: React.FC<AppLayoutWithCountProps> = ({ children, customerCount }) => {
  return (
    <SidebarProvider>
      <AppLayoutContent customerCount={customerCount}>{children}</AppLayoutContent>
    </SidebarProvider>
  )
}

export default AppLayout
